// Shared product search used by the header search panel and the catalogue page.
// Plain-language aliases so "bac water", "reta", "nad", "copper" etc. all land.
const ALIASES = {
  reta: "retatrutide", retat: "retatrutide", retatrutide: "retatrutide",
  bac: "bacteriostatic", "bac water": "bacteriostatic", bacwater: "bacteriostatic", water: "bacteriostatic",
  nad: "nad+", "nad+": "nad+",
  ghk: "ghk-cu", ghkcu: "ghk-cu", copper: "ghk-cu", "ghk cu": "ghk-cu",
  ahk: "ahk-cu", ahkcu: "ahk-cu",
  cagri: "cagrilintide", cagrilintide: "cagrilintide",
  tesa: "tesamorelin", tesamorelin: "tesamorelin",
  bpc: "bpc-157", bpc157: "bpc-157", "bpc 157": "bpc-157",
  tb500: "tb-500", "tb 500": "tb-500",
  mots: "mots-c", motsc: "mots-c", "mots c": "mots-c",
  ss31: "ss-31", "ss 31": "ss-31",
  kpv: "kpv", klow: "klow", glow: "glow", slu: "slu-pp-332", epi: "epitalon", kiss: "kisspeptin",
  ipa: "ipamorelin", glut: "glutathione", glutathione: "glutathione", semax: "semax", selank: "selank",
  ta1: "thymosin alpha", thymosin: "thymosin alpha",
};

// Compounds we deliberately don't stock — point the researcher at what we do carry.
const NOT_STOCKED = {
  tirzepatide: "Retatrutide", tirz: "Retatrutide", mounjaro: "Retatrutide", zepbound: "Retatrutide",
  semaglutide: "Retatrutide", sema: "Retatrutide", ozempic: "Retatrutide", wegovy: "Retatrutide",
};

export function normaliseQuery(q) {
  const raw = (q || "").trim().toLowerCase();
  if (!raw) return "";
  if (ALIASES[raw]) return ALIASES[raw];
  return raw.split(/\s+/).map((w) => ALIASES[w] || w).join(" ");
}

export function notStockedSuggestion(q) {
  const raw = (q || "").trim().toLowerCase();
  for (const k of Object.keys(NOT_STOCKED)) if (raw.includes(k)) return { asked: k, suggest: NOT_STOCKED[k] };
  return null;
}

export function searchProducts(products, q) {
  const nq = normaliseQuery(q);
  if (!nq) return [];
  const words = nq.split(/\s+/);
  const scored = [];
  for (const p of products) {
    if (p.visible === false) continue;
    const name = (p.name || "").toLowerCase();
    const hay = `${name} ${p.strength || ""} ${p.sku || ""} ${p.category || ""} ${p.overview || ""}`.toLowerCase();
    if (!words.every((w) => hay.includes(w))) continue;
    let score = 0;
    if (name.startsWith(words[0])) score += 3;
    else if (name.includes(words[0])) score += 2;
    if (p.stock_status !== "out_of_stock") score += 1;
    scored.push([score, p]);
  }
  return scored.sort((a, b) => b[0] - a[0] || a[1].name.localeCompare(b[1].name) || (a[1].price - b[1].price)).map(([, p]) => p);
}
